import React from "react";
import { Zap, Phone, Users, Package, MessageSquare, Wrench, CreditCard, BadgeCheck } from "lucide-react";
import { ticker } from "../mock";

const iconMap = [Zap, Phone, Users, Package, MessageSquare, Wrench, CreditCard, BadgeCheck, Zap];

export default function TickerBar() {
  const items = [...ticker, ...ticker];
  return (
    <div className="bg-ink text-white overflow-hidden border-y border-gold/30 marquee-track">
      <div className="marquee py-3">
        {items.map((t, i) => {
          const Icon = iconMap[i % iconMap.length];
          return (
            <div key={i} className="flex items-center whitespace-nowrap">
              <span className="flex items-center gap-2 px-6 text-sm font-display font-medium uppercase tracking-[0.18em]">
                <Icon size={15} className="text-gold" />
                {t}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-gold" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
